import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsPageEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsPageEntity
